import { Component, Input } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-preloader-v2',
  imports: [LottieComponent],
  templateUrl: './preloader-v2.component.html',
  styleUrl: './preloader-v2.component.scss',
})
export class PreloaderV2Component {
  @Input() text = 'Loading…';

  readonly hourglassAnimationOptions: AnimationOptions = {
    path: 'assets/animation/hourglass.json',
    loop: true,
    autoplay: true,
  };
}
